// AccountingAPI.js// 

const ACCOUNTING_API_BASE = "https://delphys7-app.online:444/api";

export default ACCOUNTING_API_BASE;